
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as gSMQXpL12gJuPi6Lx1IJYI9KrdLqysnS4_y91WJrFz4sMeta } from "/codebuild/output/src3942599000/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/g.vue?macro=true";
import { default as indexONsK8FVLdaTjwSB6ULRAc0Z_pi1ErsUU5L9RcoGRwxUMeta } from "/codebuild/output/src3942599000/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/index.vue?macro=true";
import { default as searchM82EFkamxNOnV_45bnB8YvPZM8oqxTnDBaCIM4DX5eLk0Meta } from "/codebuild/output/src3942599000/src/actions-runner/_work/onenews/onenews/web-services/common/pages/search.vue?macro=true";
import { default as indexUlgpYMeYn57kAGB_45W2tW1Pa6_457yuy_45tHax8V3Eo_btIMeta } from "/codebuild/output/src3942599000/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/index.vue?macro=true";
import { default as _91id_9378_45UZc1TlJU1GMYUdppjgwj9EPrN1t8n9R2BphuW8KsMeta } from "/codebuild/output/src3942599000/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/video/[id].vue?macro=true";
import { default as indexMZc5DYg0AgMPcCuKFmRFUQ8RjBkDKeorYVfdrps_6JYMeta } from "/codebuild/output/src3942599000/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/terms/index.vue?macro=true";
import { default as _91id_93_bjqwF9gSKA5_MnTCDDOXICic_B_vXhCcLjmD8dO2asMeta } from "/codebuild/output/src3942599000/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/article/[id].vue?macro=true";
import { default as index_453SgCLL783qdDpiQWh9tRzhSoe6xwWpuNSPek8IV57cMeta } from "/codebuild/output/src3942599000/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/contact/index.vue?macro=true";
import { default as _91id_93s_45Yc2fKzbfngtxQhwi3k69EaUPI176OY1aPv4yE6nYgMeta } from "/codebuild/output/src3942599000/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/article/[id].vue?macro=true";
import { default as indext21KHC6fflQXWSeJz8o159ZvAElTWOHgIN3pDHfKNK0Meta } from "/codebuild/output/src3942599000/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/index.vue?macro=true";
import { default as indexvcLjU_45lk_45lRtH_FB24_45elwN8GHdteMq1F6UQws9YqzAMeta } from "/codebuild/output/src3942599000/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/relationships/index.vue?macro=true";
export default [
  {
    name: "g",
    path: "/g",
    component: () => import("/codebuild/output/src3942599000/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/g.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/codebuild/output/src3942599000/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/index.vue")
  },
  {
    name: "search",
    path: "/search",
    component: () => import("/codebuild/output/src3942599000/src/actions-runner/_work/onenews/onenews/web-services/common/pages/search.vue")
  },
  {
    name: "v8",
    path: "/v8",
    component: () => import("/codebuild/output/src3942599000/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/index.vue")
  },
  {
    name: "video-id",
    path: "/video/:id()",
    component: () => import("/codebuild/output/src3942599000/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/video/[id].vue")
  },
  {
    name: "terms",
    path: "/terms",
    meta: indexMZc5DYg0AgMPcCuKFmRFUQ8RjBkDKeorYVfdrps_6JYMeta || {},
    component: () => import("/codebuild/output/src3942599000/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/terms/index.vue")
  },
  {
    name: "article-id",
    path: "/article/:id()",
    component: () => import("/codebuild/output/src3942599000/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/article/[id].vue")
  },
  {
    name: "contact",
    path: "/contact",
    meta: index_453SgCLL783qdDpiQWh9tRzhSoe6xwWpuNSPek8IV57cMeta || {},
    component: () => import("/codebuild/output/src3942599000/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/contact/index.vue")
  },
  {
    name: "v8-article-id",
    path: "/v8/article/:id()",
    component: () => import("/codebuild/output/src3942599000/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/article/[id].vue")
  },
  {
    name: "privacy-policy",
    path: "/privacy-policy",
    meta: indext21KHC6fflQXWSeJz8o159ZvAElTWOHgIN3pDHfKNK0Meta || {},
    component: () => import("/codebuild/output/src3942599000/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/index.vue")
  },
  {
    name: "privacy-policy-relationships",
    path: "/privacy-policy/relationships",
    meta: indexvcLjU_45lk_45lRtH_FB24_45elwN8GHdteMq1F6UQws9YqzAMeta || {},
    component: () => import("/codebuild/output/src3942599000/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/relationships/index.vue")
  }
]